export const NETWORK = 1
export const INFURA_RPC_URL =
  "https://mainnet.infura.io/v3/5348113af423473a85e22220ef987de8"
